import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import { Box, Inner } from './styled';
import { useMemo } from 'react';
import { toJS } from 'mobx';

const BasketballMatchRecordBoxScore = ({ item }) => {
  const {
    period,
    sortedAwayScores,
    sortedHomeScores,
    quarterArr,
    home,
    away
  } = item;
  const homeTotalScore = sortedHomeScores.reduce((a, b) => a + b.score, 0);
  const awayTotalScore = sortedAwayScores.reduce((a, b) => a + b.score, 0);
  const overTimeScore = useMemo(() => {
    const result = {
      home: '-',
      away: '-'
    };

    if (period > 4) {
      const homeScoreArr = sortedHomeScores.filter((score) => score.period > 4);

      if (homeScoreArr.length > 0) {
        result.home = homeScoreArr.reduce((a, c) => a + c.score, 0);
      }

      const awayScoreArr = sortedAwayScores.filter((score) => score.period > 4);

      if (awayScoreArr.length > 0) {
        result.away = awayScoreArr.reduce((a, c) => a + c.score, 0);
      }
    }

    return result;
  }, [period, sortedHomeScores, sortedAwayScores]);

  const overTimeSummary = useMemo(() => {
    if (period > 4) {
      return overTimeScore.away + overTimeScore.home;
    } else {
      return '-';
    }
  }, [period, overTimeScore]);

  return (
    <Box className={clsx('basic_board')}>
      {/* 클래스 : overtime */}
      <Inner>
        <dl className={clsx('item', 'team')}>
          <dt>팀명</dt>
          <dd>{away.name}</dd>
          <dd>{home.name}</dd>
          <dd></dd>
        </dl>
        {quarterArr.map((quarter, idx) => {
          const awayScore = sortedAwayScores[idx] || null;
          const homeScore = sortedHomeScores[idx] || null;
          if (quarter.value > 4 || awayScore === null || homeScore === null) {
            return null;
          } else {
            return (
              <dl
                className={clsx('item', 'score')}
                key={`box-item-${quarter.value}`}
              >
                <dt>{quarter.key}</dt>
                <dd>{awayScore.score}</dd>
                <dd>{homeScore.score}</dd>
                <dd>{awayScore.score + homeScore.score}</dd>
              </dl>
            );
          }
        })}
        <dl className={clsx('item', 'score')}>
          <dt>연장</dt>
          <dd>{overTimeScore.away}</dd>
          <dd>{overTimeScore.home}</dd>
          <dd>{overTimeSummary}</dd>
        </dl>
        <dl className={clsx('item', 'score')}>
          <dt>합계</dt>
          <dd>{awayTotalScore}</dd>
          <dd>{homeTotalScore}</dd>
          <dd>{awayTotalScore + homeTotalScore}</dd>
        </dl>
      </Inner>
    </Box>
  );
};

export default BasketballMatchRecordBoxScore;
